module.exports = __webpack_public_path__ + "assets/img/img-course-plan01.a55763b7.png";